import http from '@/utils/request';
import { API_BASE } from '@/config';

// 图片、文件上传 API 路径
export const UPLOAD_FILE_API = `${API_BASE.open}/api/file/upload`;

/**
 * 图片、文件上传
 *
 * @param {*} data
 * @returns
 */
export const uploadFile = (data) => http.post({
  url: UPLOAD_FILE_API,
  data,
  server: 'open',
  loading: true,
});
